<template>
    <div class="sdk-dimension-container">
        <el-form :model="params" ref="form" :label-width="labelWidth">
            <el-form-item label="登录方式：">
                <el-checkbox :indeterminate="isIndeterminate" v-model="login_buttons_check_all" @change="handleCheckAllChange">全选</el-checkbox>
                <el-checkbox-group v-model="params.logins" @change="handleCheckedCitiesChange">
                    <span  v-for="item in loginOptions" :key="item.key">
                        <el-checkbox :label="item.key"
                            :class="{'margin_left0': true}" :disabled="item.disabled" >
                            <el-tooltip
                                :content="item.label+'登录'"
                                placement="top"
                                ><span>{{item.label}}</span>
                            </el-tooltip>
                        </el-checkbox>
                    </span>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="登录相关功能：" v-if="platform !=='H5'">
                <el-checkbox-group v-model="params.login_featured">
                    <el-checkbox label="silence_login_allowed" :disabled="is_anti_addiction_turn_on || storeCode=='qooapp' || platform=='WINDOWS'">自动登录</el-checkbox>
                    <el-checkbox label="silent_game_center_login_allowed" v-if="platform === 'IOS'" :disabled="params.logins.indexOf('gamecenter_allowed') < 0">GC静默关联</el-checkbox>
                    <el-checkbox label="prompt_to_bind_anonymous_account" v-if="platform !=='WINDOWS'">关联提示</el-checkbox>
                </el-checkbox-group>
            </el-form-item>

            <el-form-item label="邮箱注册验证：" v-if="version >= 7.14 && platform!=='H5' && platform !='WINDOWS'">
                <el-radio-group v-model="params.email_registration_verify_allowed" @change="params.recaptcha_allowed = false;">
                    <el-radio :label="true">开启</el-radio>
                    <el-radio :label="false">关闭</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="reCAPTCHA开关：" v-if="version >= 7.14 && platform!=='H5' && platform !='WINDOWS'">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        placement="top-start"
                    >
                    <div slot="content">开启时，请确认reCAPTCHA Sign-Up Key是否配置。生成reCAPTCHA Sign-Up Key请联系平台产品组；<br/>开启后，针对玩家的注册行为将启用Google的机器人验证功能，可一定程度防止刷号。</div>
                        <i
                            class="el-icon-question"
                            style="margin-left: -17px;"
                        ></i>
                    </el-tooltip>

                <el-radio-group v-model="params.recaptcha_allowed">
                    <el-radio :label="true" :disabled="params.email_registration_verify_allowed">开启</el-radio>
                    <el-radio :label="false" :disabled="params.email_registration_verify_allowed">关闭</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="reCAPTCHA分值：" v-if="version >= 7.14 && platform!=='H5' && platform !='WINDOWS' && params.recaptcha_allowed && !params.email_registration_verify_allowed">
                  <div>
                    低风险
                    <el-input-number v-model="params.recaptcha_low_risk_score" size="mini" :precision="2" :max="1" :step="0.01" :min="0" class="w70 hidden"></el-input-number>
                    <span @click.stop style="color: #606266">  请输入0-1区间的小数，精确到小数点后两位，如0.85</span>
                  </div>
                  <div>
                    高风险
                    <el-input-number v-model="params.recaptcha_high_risk_score" size="mini" :precision="2" :step="0.01" :max="1" :min="0" class="w70 hidden"></el-input-number>
                    <span @click.stop style="color: #606266">  请输入0-1区间的小数，精确到小数点后两位，如0.35</span>
                  </div>
                  <div style="color: #e6a23c;line-height:28px">
                    说明：reCAPTCHA会根据访问者与您网站的互动情况提供一个分数，1.0 表示很可能完全正常的互动，0.0 表明很可能具有滥用性质的操作。
                    <br/>SDK会根据reCAPTCHA互动情况把0.8-1的玩家定义为安全玩家，0.3-0.8为需要二次验证的玩家，0-0.3的玩家为危险玩家系统将拒绝玩家继续操作。
                  </div>
            </el-form-item>


            <el-form-item label="密码复杂程度要求" v-if="version >= 7.15 && platform!=='H5' && platform !='WINDOWS'">
                <el-radio-group v-model="params.password_level">
                    <el-radio label="low">
                      简单
                        <el-tooltip
                          class="item"
                          effect="dark"
                          content="6-20位字符，可输入大写字母、小写字母、数字和常见特殊字符。"
                          placement="top-start"
                      >
                          <i
                              class="el-icon-question"
                          ></i>
                      </el-tooltip>
                    </el-radio>
                    <el-radio label="high">
                      复杂
                      <el-tooltip
                          class="item"
                          effect="dark"
                          content="8-20位字符，可输入大写字母、小写字母、数字和常见特殊字符，至少两种组合。"
                          placement="top-start"
                      >
                          <i
                              class="el-icon-question"
                          ></i>
                      </el-tooltip>
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="是否优先确认协议：" v-if="version >= 7.07 && platform!=='H5' && platform !='WINDOWS'">
                <el-radio-group v-model="params.priority_to_confirm_allowed">
                    <el-radio :label="true">开启</el-radio>
                    <el-radio :label="false">关闭</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="用户注册协议展示方式" v-if="version >= 7.15 && platform!=='H5' && platform !='WINDOWS'">
                <el-radio-group v-model="params.licence_show_type">
                    <el-radio label="merge" @change="selectMerageShowType">
                      与注册页面合并展示<em class="el-icon-view icon-view1"  @click.stop="licenceShowTypeMerge = true"></em>
                    </el-radio>
                    <el-radio label="single">
                      协议单独弹框展示<em class="el-icon-view icon-view1"  @click.stop="licenceShowTypeSingle = true"></em>
                    </el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="用户须确认协议" v-if="version >= 7.15 && platform!=='H5' && platform !='WINDOWS'">
                  <el-checkbox v-model="params.must_confirm_licence.user_licence" :disabled="true">用户协议</el-checkbox>
                  <el-checkbox v-model="params.must_confirm_licence.secure_licence" :disabled="true">隐私政策</el-checkbox>
                  <el-checkbox v-model="params.must_confirm_licence.years_old" v-if="params.licence_show_type == 'single'" @change="checkYearsOld">
                    确认已满<el-input-number v-model="params.confirm_licence_years_old" size="mini" :max="100" :step="1" precision="0" :min="0" :controls="false" class="w45 hidden" :disabled="!params.must_confirm_licence.years_old"></el-input-number>岁
                  </el-checkbox>
            </el-form-item> 
            <el-form-item label="主推登录方式：" v-if="version >= 7.07 && platform!=='H5' && platform !='WINDOWS'">
                <el-radio-group v-model="params.recommend_login_mode" @change="handleFeaturedLogins">
                    <el-radio label="mobile_and_email" :disabled="params.logins.indexOf('mobile_allowed') === -1">邮箱和手机</el-radio>
                    <el-radio label="email">邮箱</el-radio>
                    <el-radio label="mobile" :disabled="params.logins.indexOf('mobile_allowed') === -1">手机号</el-radio>
                </el-radio-group>
                <div class="img-border"  v-show="params.recommend_login_mode" v-loading="urlLoding">
                    <h3> 效果预览</h3>
                    <img :src="activeUrl" alt=""/>
                </div>
            </el-form-item>
            <el-form-item label="登录页面logo：" v-if="(version >= 7.08) || platform==='H5' || platform==='WINDOWS' ">
                <div class="dialog-upload-btn-box">
                <div class="upload-imgs">
                    <el-form-item label-width="0">
                        <div v-if="platform!=='WINDOWS'">尺寸要求： 高144px，宽480-880px <font color="red">(请上传png格式)</font></div>
                        <div v-if="platform==='WINDOWS'">尺寸要求： 高56px，宽56-366px <font color="red">(请上传png格式)</font></div>
                        <upload :size="platform==='WINDOWS'? '366*56px': '880*144px'" formatlimit="png" v-model="params.login_page_logo"></upload>
                    </el-form-item>
                </div>
                </div>
            </el-form-item>
            <el-form-item>
                <el-button class="next-button" type="primary" size="small" @click="handlerNext" v-if="!isDetail">下一步</el-button>
            </el-form-item>
        </el-form>
        <el-dialog
            class="el-dialog__body_self"
            title=""
            :visible.sync="licenceShowTypeMerge"
            width="1220px">
            <div class="flex dialog-img-box">
                <div>
                    <img src="../../assets/licence_show_type_merge.png" width="1180" alt="" />
                </div>
            </div>
        </el-dialog>
        <el-dialog
            class="el-dialog__body_self"
            title=""
            :visible.sync="licenceShowTypeSingle"
            width="1220px">
            <div class="flex dialog-img-box">
                <div>
                    <img src="../../assets/licence_show_type_single.png" width="1180" alt="" />
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { mapState } from "vuex";
import upload from '../../subComponents/sdkUpload';
export default {
    name: 'set-login-allowed',
    components: {
        upload
    },
    data() {
        return {
            login_buttons_check_all: '',
            isIndeterminate: false,
            operate_type: '',
            platform: '',
            is_anti_addiction_turn_on: false,
            params: {
                logins: [],
                login_featured: [],
                recommend_login_mode: '',
                priority_to_confirm_allowed: false,
                email_registration_verify_allowed: false,
                recaptcha_allowed: false,
                recaptcha_low_risk_score:0.8,
                recaptcha_high_risk_score:0.3,
                step: 'login',
                login_page_logo: '',
                password_level: "low",
                licence_show_type: "merge",
                must_confirm_licence: {
                    user_licence:true,
                    secure_licence: true,
                    years_old:false
                },
                confirm_licence_years_old:0
            },
            urlLoding: false,
            isVersion5x: false,
            version: '',
            storeCode:"",
            copyCheckeds: [],
            licenceShowTypeSingle: false,
            licenceShowTypeMerge:false,
            loginMethods: [
                {
                    label: '邮箱',
                    key: 'email_allowed',
                    disabled: true
                },
                {
                    label: '邮箱',
                    key: 'email_allowed',
                    disabled: true,
                    platform: 'H5'
                },
                {
                    label: '邮箱',
                    key: 'email_allowed',
                    disabled: true,
                    platform: 'WINDOWS'
                },
                {
                    label: '手机号',
                    key: 'mobile_allowed'
                },
                {
                    label: 'Apple',
                    key: 'apple_allowed',
                    platform: 'IOS'
                },
                {
                    label: 'Gamecenter',
                    key: 'gamecenter_allowed',
                    platform: 'IOS'
                },
                {
                    label: 'Facebook',
                    key: 'facebook_allowed'
                },
                {
                    label: 'Facebook',
                    key: 'facebook_allowed',
                    platform: 'H5'
                },
                {
                    label: 'Facebook',
                    key: 'facebook_allowed',
                    platform: 'WINDOWS'
                },
                {
                    label: 'Line',
                    key: 'line_allowed'
                },
                {
                    label: 'VK',
                    key: 'vk_allowed'
                },
                {
                    label: 'Google',
                    key: 'google_allowed',
                    platform: 'ANDROID'
                },
                {
                    label: 'Google',
                    key: 'google_allowed',
                    platform: 'H5'
                },
                {
                    label: 'Google',
                    key: 'google_allowed',
                    platform: 'WINDOWS'
                },
                {
                    label: 'Twitter',
                    key: 'twitter_allowed'
                },
                {
                    label: 'QooApp',
                    key: 'qooapp_allowed',
                    platform: 'ANDROID'
                },
            ]
        };
    },
    props: ['isDetail', 'isCopy', 'labelWidth'],
    computed: {
        ...mapState(['$helper', '$lodash']),
        ...mapState("sdkReleasesEdit", [
            "gameVersion",
            "packageList",
            "packageStoreList",
            "sdkVersion",
            "data"
        ]),
        activeUrl() {
            const urls = {
                mobile_and_email: require('../../assets/login-phone-email.png'),
                email: require('../../assets/login-email.png'),
                mobile: require('../../assets/login-phone.png'),
            };
            return this.params.recommend_login_mode ? urls[this.params.recommend_login_mode] : '';
        },
        loginOptions() {
            return this.loginMethods.filter((item, i) => {
                // if(this.isVersion5x && item.label === 'Twitter') {
                //     return false;
                // }
                if (this.platform === "H5") {
                    return item.platform && item.platform === "H5";
                }
                else if (this.platform === "WINDOWS") {
                    return item.platform && item.platform === "WINDOWS";
                }
                else {
                    return !(item.platform && item.platform !== this.platform);
                }

            });
        }
    },
    watch: {
        'data.query'(value) {
            let version = "", storeCode = "";
            this.sdkVersion.forEach(item => {
                if (parseInt(value.sdk_version_id) === parseInt(item.sdk_version_id)) {
                    version = item.version;
                }
            });
            const versionStr = version.substr(0, 2);
            version = this.justifyVersion(version);
            this.version = parseFloat(version);
            if (!['5.'].includes(versionStr)) {
                this.isVersion5x = true;
            }
            this.packageStoreList.forEach(item => {
                if (parseInt(value.store_id) === parseInt(item.store_id)) {
                    storeCode = item.store_code;
                }
            });
            this.storeCode = storeCode;
            
        },
        'data.login' () {
            let options = this.loginOptions.map(item => item.key);
            console.log("aaaaa", options);

            this.data.login.logins = this.data.login.logins.filter((item) => {
                return !!options.includes(item);
            });
            console.log(123123, this.data.login);
            this.params = this.$lodash.cloneDeep(this.data.login);
            this.params.step = 'login';
            this.handleCheckedCitiesChange(this.params.logins, true);
            if (this.params.email_registration_verify_allowed) { 
                this.params.recaptcha_allowed = false;
            }
            
        },
        'data.feature'() {
            this.is_anti_addiction_turn_on = typeof this.data.feature.is_anti_addiction_turn_on !== 'undefined' ? this.data.feature.is_anti_addiction_turn_on : false;

            if (this.storeCode === 'qooapp') {
                console.log(this.params.login_featured);
                this.params.login_featured.splice(this.params.login_featured.indexOf('silence_login_allowed'), 1);
                this.loginMethods.forEach(item => {
                    if (item.key === "qooapp_allowed") {
                        item.disabled = false;
                        // item.ischecked = false;
                    }
                });
            }
            else { 
                // this.params.logins.splice(this.params.logins.indexOf('qooapp_allowed'), 1);
                this.loginMethods.forEach(item => {
                    if (item.key === "qooapp_allowed") {
                        item.disabled = true;
                    }
                });
            }
        },
    },
    methods: {
        handleFeaturedLogins() {
            this.urlLoding = true;
            setTimeout(() => {
                this.urlLoding = false;
            }, 500);
        },
        selectMerageShowType (isChecked) {
            if (isChecked) {
                this.params.must_confirm_licence.years_old = false;
                this.params.confirm_licence_years_old = 0;
            }
        },
        checkYearsOld (isChecked) { 
            if (isChecked) {
                this.params.confirm_licence_years_old = 14;
            }
            else { 
                this.params.confirm_licence_years_old = 0;
            }
        },
        handleCheckAllChange (isChecked) {

            console.log("bbbbb", this.loginOptions);
            console.log('ccc', this.params.logins);
            this.params.logins = isChecked ? this.loginOptions.map(item => 
              item.key) : ['email_allowed'];
            console.log('dddd', this.params.logins);
            this.params.recommend_login_mode = isChecked ? 'mobile_and_email' : 'email';
            this.isIndeterminate = false;
            if (this.platform == 'ANDROID' && this.storeCode !== 'qooapp' && isChecked) { 
                this.params.logins.splice(this.params.logins.indexOf('qooapp_allowed'), 1);
            }
            console.log('eeeee', this.params.logins);
        },
        handleCheckedCitiesChange (checkeds, bOk = false) {
            let checkedCount = checkeds.length;
            console.log(checkeds.length);
            this.login_buttons_check_all = checkedCount === this.loginOptions.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.loginOptions.length;
            let check = ['mobile_allowed', 'email_allowed'].includes(this.$lodash.difference(checkeds, this.copyCheckeds).join()),
                r_check = ['mobile_allowed', 'email_allowed'].includes(this.$lodash.difference(this.copyCheckeds, checkeds).join());
            if (!bOk && check || !bOk && r_check) {
                this.params.recommend_login_mode = checkeds.indexOf('mobile_allowed') > -1 ? 'mobile_and_email' : 'email';
            }
            this.copyCheckeds = checkeds;
            if (this.params.logins.indexOf('gamecenter_allowed') === -1 && this.params.login_featured.indexOf('silent_game_center_login_allowed') > -1) {
                this.params.login_featured.splice(this.params.login_featured.indexOf('silent_game_center_login_allowed'), 1);
            }
        },

        handlerNext() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.$emit('submit', this.params);
                    console.log(this.params);
                }
            });
        },
        justifyVersion(version) {
            let versionarr = version.split(".");
            let version_convert = '';
            if (versionarr[1] < 10) {
                version_convert = versionarr[0] + ".0" + versionarr[1];
            }
            else {
                version_convert = version;
            }
            return version_convert;
        },
    },
    created() {
        this.operate_type = this.$helper.helper.getParamers("operate_type");
        this.platform = this.$helper.helper.getParamers("platform");
    }
};
</script>
<style lang="scss" scoped>
    .sdk-dimension-container {
        .dialog-upload-btn-box {
            .upload-imgs {
                display: flex;
                text-align: center;

                .avatar-box {
                    border: 1px dashed #d9d9d9;
                    border-radius: 6px
                }

            }
            .el-tabs__item {
                padding: 0 !important;
                width: 70px;
                text-align: center;
            }
            .el-tabs__header {
                width: 560px;
            }
            .upload-success, .upload-warning {
                width: 5px;
                height: 5px;
                border-radius: 50%;
                display: inline-block;
                margin-bottom: 7px;
            }
            .upload-success {
                background: #67C23A;
            }
            .upload-warning {
                background: #F56C6C;
            }
        }
    }
    .sdkconfigedit-formitem-width{
        width: 500px;
    }
    .margin_left0{
        margin-left: 0;
    }
    .w45{
      width:45px;
    }
    .push-operate-container .icon-view1 {
    border: 1px dashed #409EFF;
    color: #409EFF;
    font-size: 16px;
    padding: 3px;
    position: absolute;
    top: -4px;
    cursor: pointer;
}
    .img-border{
        border: 2px dashed #C0C4CC;
        padding: 10px 20px 20px;
        display: inline-grid;
        background: #fcfcfc;
        margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// website/subComponents/sdk/SetLoginAllowed.vue